import React, { useState, useEffect, useRef } from "react";
import { Progress } from "react-sweet-progress";
import "react-sweet-progress/lib/style.css";
import CardTaskDetail from "../../components/Card/CardTaskDetail";
import { Link, useHistory, useLocation } from "react-router-dom";
import { serverUrl } from "../../components/Helpers/Config";
import axios from "axios";
import moment from "moment";
import BoltIcon from "@mui/icons-material/Bolt";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { BiSolidHourglass } from "react-icons/bi";
import {
  htmlToText,
  addAttribute,
  tokenAuthorize,
} from "../../components/Helpers/Common";
import {
  BgBlue,
  ButtonCommonTopNew,
  SideBarActiveDiv,
  SideBarActiveDivButtonNew,
  SideBarNormalDivButtonNew,
  TextGray,
} from "../Theme";
// import { Button } from "reactstrap";
import Button from "../../components/Button/Button";
import ButtonBlue from "../../components/Button/ButtonBlue";
import noprofile from "../../common/images-new/no-profile-pic.png";
import ButtonCommon from "../../components/Button/ButtonCommon";
import { useSelector, useDispatch } from "react-redux";
import { BiLeftArrowAlt } from "react-icons/bi";
import { Select, MenuItem } from "@mui/material";
import { BsArrowLeft } from "react-icons/bs";
import { GET_THEME_LOADER } from "../../redux/actions/auth";
const noProfile = noprofile;

export default function Detail(props) {
  //const data = props.location.state.list;
  const dispatch = useDispatch();
  const isDefaultTheme = useSelector((state) => state.auth.isDefaultTheme);
  const userTheme = useSelector((state) => state.auth.theme);
  const history = useHistory();
  const location = useLocation();
  const id = props.match.params.id;
  const [isExpanded, setIsExpanded] = useState(true);
  const [currentTask, setCurrentTask] = useState(null);
  const taskRefs = useRef({});

  // Scroll page to the task set from location.state.taskId (with 50px offset)
  useEffect(() => {
    const currentTaskId = location.state?.taskId;
    if (currentTaskId && currentTask?.task_id === currentTaskId) {
      const el = taskRefs.current[currentTaskId];
      if (el) {
        const rect = el.getBoundingClientRect();
        window.scrollTo({
          top: window.pageYOffset + rect.top - 50,
          behavior: "smooth",
        });
      }
    }
  }, [currentTask]);
  const [data, setData] = useState({
    name: "",
    desc: "",
    due: "",
    icon: "",
    done: 0,
    tasks: [],
  });

  // const [totalTask, setTotalTask] = useState(0);

  // useEffect(() => {
  //   setTotalTask(
  //     //data.task.filter((list) => list.completed === true).length
  //   )
  // })

  useEffect(() => {
    if (id) {
      refreshData(true);
    }
  }, [id]);

  const [tutorGuid, setTutorGuid] = useState("");
  const [tutorProfile, setTutorProfile] = useState(null);
  const [tutorName, setTutorName] = useState("");

  const formatModernDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "short", // Jan, Feb, Mar, etc.
      day: "numeric", // 1, 2, 3...
    });
  };

  useEffect(() => {
    axios
      .get(serverUrl.Task + `/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setTutorGuid(res.data?.tutor_guid);
          setTutorProfile(res.data?.tutor_profile);
          setTutorName(res.data?.tutor_name);
        }
      })
      .catch((error) => {
        tokenAuthorize(error?.response?.status);
      });
  }, [id]);

  const goBack = () => {
    const prevPage = location.pathname.toLowerCase().startsWith("/tasks/mytask")
      ? "/tasks/mytask"
      : "/tasks";

    history.push(prevPage);
  };

  const refreshData = (value = false) => {
    if (value == true) {
      dispatch({ type: GET_THEME_LOADER, payload: true });
      //localStorage.setItem("themeLoader", true);
    }
    axios
      .get(
        (props.location &&
          props.location.pathname &&
          props.location.pathname.toLowerCase().startsWith("/tasks/mytask")
          ? serverUrl.LearningMyTask
          : serverUrl.Learning) + `/${id}`
      )
      .then((resp) => {
        if (resp.status === 200) {
          const data = resp.data;
          // g(data)
          setData({
            name: data.list_name,
            course: data.group_name,
            desc: data.list_desc,
            due: data.list_due,
            created: moment(data.list_created).format("DD/MM/YYYY"),
            icon: moment(data.list_due).date(),
            tasks:
              data.tasks?.length > 0
                ? data.tasks?.sort((a, b) => a.task_order - b.task_order)
                : [],
            done: parseInt(data.task_done),
          });
          if (!currentTask) {
            const currentTaskId = location.state?.taskId;
            const currentTaskMatch = currentTaskId
              ? data.tasks?.find((task) => task.task_id === currentTaskId)
              : null;
            setCurrentTask(
              currentTaskMatch ?? (data.tasks?.length > 0 ? data.tasks[0] : null)
            );
          } else {
            const updatedTask = data.tasks?.find(
              (task) => task.task_id === currentTask.task_id
            );
            setCurrentTask(updatedTask ?? null);
          }
          //localStorage.setItem("themeLoader", false);
          dispatch({ type: GET_THEME_LOADER, payload: false });

          // let dueDate = new Date(data.list_due);
          // const tzoffset = dueDate.getTimezoneOffset() * 60000;
          // const tzDueDate = (new Date(dueDate.getTime() - tzoffset)).toISOString().substr(0,10);

          // let created = new Date(data.list_created);
        }
      })
      .catch((error) => {
        //localStorage.setItem("themeLoader", false);
        dispatch({ type: GET_THEME_LOADER, payload: false });
        tokenAuthorize(error?.response?.status);
      });
  };
  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className=" pt-2 md:pt-4">
      <div className=" flex-col mt-4 px-5 whitespace-nowrap">
        <div className="flex  text-sm  items-center gap-4">
          <div
            className={`rounded-lg p-0 flex gap-1 items-center w-max cursor-pointer`}
            onClick={goBack}
          >
            <KeyboardBackspaceIcon
              style={{ fontSize: "28px" }}
              className=" primaryIcon"
            />
            <h1 className="text-lg blueColor font-semibold">Back</h1>
          </div>
          <p className="text-3xl font-bold flex-1 min-w-0 flex justify-center wrap-text">
            {data.name}
          </p>
        </div>

        <div className="flex text-sm  items-center justify-between  gap-5 mt-5 flex-wrap">
          {tutorName !== "" && (
            <div className="flex itesm-center gap-5 items-center">
              <div className="flex items-center gap-2">
                {tutorName !== "" && (
                  <>
                    <Link to={"/profile/" + tutorGuid} target="_blank">
                      <img
                        src={tutorProfile ? tutorProfile : noProfile}
                        className="w-12 h-12 rounded-full object-cover "
                      />
                    </Link>
                    <div className="flex flex-col">
                      {data.course && (
                        <span className="text-lg font-semibold blackColor">
                          {data.course}
                        </span>
                      )}
                      {tutorName && (
                        <span className="text-md blackColor flex gap-1.5">
                          {tutorName}
                        </span>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
          <div className="flex items-center gap-5 flex-wrap">
            <div className="text-md blackColor flex items-center gap-1">
              <span className="lightColor">Task completed:</span>{" "}
              {data.tasks.length > 0
                ? Math.floor((data.done / data.tasks.length) * 100)
                : 0}
              %
            </div>
            <div>
              <span className="text-md blackColor flex items-center gap-1">
                <span className="lightColor">Due on:</span>{" "}
                {data.due ? formatModernDate(data.due) : ""}
              </span>
            </div>
          </div>
        </div>
        <div
          className="mt-4  text-viewer  w-full min-w-0 overflow-hidden break-words wrap-text"
          dangerouslySetInnerHTML={{
            __html: addAttribute(data.desc),
          }}
        />
      </div>
      <div className="flex text-sm  w-full h-full border-top-f1 flex-col lg:flex-row">
        <div className="w-64 border-right-f1 pl-4 pr-5 py-4 hidden lg:block">
          <SideBarActiveDiv className="font-14px font-semibold  py-1">
            Tasks
          </SideBarActiveDiv>
          <div className="flex flex-col flex-1 mt-1 border-left-f1 ml-1 pl-2">
            {data.tasks.map((list, index) =>
              currentTask?.task_id === list.task_id ? (
                <SideBarActiveDivButtonNew
                  type="button"
                  className="font-14px  flex items-center justify-between text-left whitespace-normal py-1 my-1 pl-2 pr-2 w-full cursor-pointer font-medium"
                  key={index}
                  ref={(el) => (taskRefs.current[list.task_id] = el)}
                  onClick={() => setCurrentTask(list)}
                >
                  {list.task_name}{" "}
                  {list.response_status == true ? (
                    <CheckCircleIcon
                      className="w-5 h-5"
                      // style={{
                      //   color:
                      //     isDefaultTheme == false
                      //       ? userTheme?.color2
                      //       : "#66D692",
                      // }}
                      style={{
                        color:
                          userTheme == "" || userTheme == "default theme"
                            ? "#66D692"
                            : userTheme?.color2,
                      }}
                    />
                  ) : (
                    <CheckCircleIcon
                      // style={{
                      //   color:
                      //     isDefaultTheme == false
                      //       ? userTheme?.color2
                      //       : "#F4A300",
                      //   fontSize: "18px",
                      // }}
                      className="w-5 h-5 secondaryIcon flex-shrink-0"
                    />
                  )}
                </SideBarActiveDivButtonNew>
              ) : (
                <SideBarNormalDivButtonNew
                  type="button"
                  className="font-14px flex items-center justify-between text-left whitespace-normal lightColor pl-2 pr-2 my-1 pb-1 pt-1 w-full cursor-pointer font-medium"
                  key={index}
                  ref={(el) => (taskRefs.current[list.task_id] = el)}
                  onClick={() => setCurrentTask(list)}
                >
                  <span
                    className={`${list.response_status == true ? "blackColor break-anywhere whitespace-normal" : "break-anywhere whitespace-normal"
                      }`}
                  >
                    {list.task_name}
                  </span>
                  {list.response_status == true ? (
                    <CheckCircleIcon
                      className="w-5 h-5"
                      style={{
                        color:
                          userTheme == "" || userTheme == "default theme"
                            ? "#66D692"
                            : userTheme?.color2,
                      }}
                    />
                  ) : (
                    <CheckCircleIcon
                      className="w-5 h-5 secondaryicon flex-shrink-0"
                    />
                  )}
                </SideBarNormalDivButtonNew>
              )
            )}
          </div>
        </div>
        <div className=" py-5 ml-1 px-5 cardBackgroundColor flex items-center lg:hidden gap-2">
          <span className="text-sm blackColor">Tasks:</span>
          <Select
            labelId="task-select-label"
            className="w-44"
            style={{ height: "35px" }}
            value={currentTask?.task_id || ""}
            onChange={(e) => {
              const selected = data.tasks.find(
                (t) => t.task_id === e.target.value
              );
              if (selected) setCurrentTask(selected);
            }}
            MenuProps={{
              disableScrollLock: true,
            }}
          >
            {data.tasks.map((task) => (
              <MenuItem key={task.task_id} value={task.task_id}>
                {task.task_name}
              </MenuItem>
            ))}
          </Select>
        </div>
        <div className="flex-1 backGroundColor p-5 border20pxbottomright">
          {currentTask && (
            <CardTaskDetail
              key={currentTask.task_id}
              data={{
                id: currentTask.task_id,
                name: currentTask.task_name,
                completed: currentTask.response_status,
                action: currentTask.response_type
                  ? currentTask.response_type
                  : 0,
                detail: currentTask.detail || "",
                attachments: currentTask.attachment_link || [],
                fileurl: currentTask.file_url || [],
              }}
              dueDate={data.due}
              onPostUpdate={refreshData}
              toggleExpansion={isExpanded}
            />
          )}
          {/* {(data.tasks.length > 0 &&
            data.tasks.map((list, index) => (
              <CardTaskDetail
                key={index}
                data={{
                  id: list.task_id,
                  name: list.task_name,
                  completed: list.response_status,
                  action: list.response_type ? list.response_type : 0,
                  detail: list.detail || "",
                  attachments: list.attachment_link || [],
                  fileurl: list.file_url || [],
                }}
                dueDate={data.due}
                onPostUpdate={refreshData}
                toggleExpansion={isExpanded}
              />
            ))) ||
            null} */}
        </div>
      </div>
    </div>
  );
}
